// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.upload-container[data-v-26324a24] {\n  margin-bottom: 20px;\n}\n.dialog-footer[data-v-26324a24] {\n  text-align: right;\n}\n.audit-section[data-v-26324a24] {\n  margin-top: 20px;\n  padding-top: 20px;\n  border-top: 1px solid #f0f0f0;\n}\n.el-form-item[data-v-26324a24] {\n  margin-bottom: 15px;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
